import { ReactComponent as FailedIcon } from "assets/icons/FailedIcon.svg";
import { ReactComponent as SucessIcon } from "assets/icons/SucessIcon.svg";
import cuid from "cuid";
import { useMobileView } from "hook/mobileView/useMobileView";
import moment from "moment";
import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { eventsSlice, setCounterTicket } from "services/api/events";
import { ButtonWrapper, CalendarButton, CalendarIconButton, CalendarIconsRow, CalendarLabel, CardContent, DoneButton, ShareButton, ThanksMsg, Title, Wrapper } from "./Theme";

const GoogleIcon = () => (
	<svg width="30" height="30" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
		<path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
		<path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
		<path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
		<path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
	</svg>
);

const AppleIcon = () => (
	<svg width="30" height="30" viewBox="0 0 814 1000" xmlns="http://www.w3.org/2000/svg">
		<path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-37.5-155.5-127.4C46 790.6 0 663 0 541.8c0-207.9 135.4-318 268.5-318 71 0 130.3 46.3 175.7 46.3 43.4 0 111.8-49.2 190.5-49.2zm-101.2-147.7c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z" fill="#555"/>
	</svg>
);

const OutlookIcon = () => (
	<svg width="30" height="30" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<path d="M7.88 12.04q0 .45-.11.87-.1.41-.33.74-.22.33-.58.52-.37.2-.87.2t-.85-.2q-.35-.21-.57-.55-.22-.33-.33-.75-.1-.42-.1-.86t.1-.87q.1-.43.34-.76.22-.34.59-.54.36-.2.87-.2t.86.2q.35.21.57.55.22.34.33.77.1.43.1.88zM24 12v9.38q0 .46-.33.8-.33.32-.8.32H7.13q-.46 0-.8-.33-.32-.33-.32-.8V18H1q-.41 0-.7-.3-.3-.29-.3-.7V7q0-.41.3-.7Q.58 6 1 6h6.5V2.55q0-.44.3-.75.3-.3.75-.3h12.9q.44 0 .75.3.3.3.3.75V10.85l1.24.72h.01q.4.22.4.63zm-8-6h-4v1.88h4zm0 3h-4v1.88h4zm0 3h-4v1.88h4zm1.5-6h-1v7.5q0 .36-.25.65l-3.69 4H20V6zm1.5 9.09L17.73 19H22V15.09z" fill="#0078D4"/>
	</svg>
);

const Office365Icon = () => (
	<svg width="30" height="30" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
		<rect x="1" y="1" width="9" height="9" fill="#F25022"/>
		<rect x="13" y="1" width="9" height="9" fill="#7FBA00"/>
		<rect x="1" y="13" width="9" height="9" fill="#00A4EF"/>
		<rect x="13" y="13" width="9" height="9" fill="#FFB900"/>
	</svg>
);

const YahooIcon = () => (
	<svg width="30" height="30" viewBox="0 0 248 283" xmlns="http://www.w3.org/2000/svg">
		<path d="M0 0l99.8 141.4L.4 282.9h48.6l51.6-75.5 51.2 75.5H200l-99-141.6L199.4 0H152l-27.6 42.7-48-42.7H0z" fill="#6001D2"/>
	</svg>
);

const IcsCalendarIcon = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="3" y="4" width="18" height="17" rx="2" stroke="#fff" strokeWidth="2"/>
		<path d="M3 9h18" stroke="#fff" strokeWidth="2"/>
		<path d="M8 2v4M16 2v4" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
		<path d="M8 13h2M14 13h2M8 17h2M14 17h2" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
	</svg>
);

export const PaymentResultPage = ({ result, formik, isTherePayment, showThanksMsg, eventData, selectedVariants, selectedEventDates }) => {
	const orgWebsite = localStorage.getItem("shul_website") || "";
	const { isMobile } = useMobileView();
	const dispatch = useDispatch();
	const history = useHistory();
	const lastCardNum = formik?.values?.cardsDetails?.card_number?.slice(-4);
	const entrySource = sessionStorage.getItem("entrySource");
	const isFromApp = entrySource === "app";

	const handleCancel = () => {
		dispatch(eventsSlice.actions.setTotalProducts(0));
		// formik.setFieldValue('resultPage', '')
		formik.setFieldValue("accountInfo", {});
		formik.setFieldValue("cardsDetails", {});
		dispatch(setCounterTicket([cuid()]));
		localStorage.setItem("registrationForm", JSON.stringify([]));
		localStorage.setItem("ApplayCheckBox", JSON.stringify(false));
		orgWebsite ? window.location.replace(orgWebsite) : history.push("/events");
	};

	const successTitle = isTherePayment ? "Payment Succeeded!" : "Thank You";

	const parseDurationMinutes = (key) => {
		if (!key) return 30;
		const [amount, unit] = key.toLowerCase().split(" ");
		const num = parseFloat(amount);
		if (isNaN(num)) return 30;
		return unit?.startsWith("hour") ? Math.round(num * 60) : Math.round(num);
	};

	const getCalendarEntries = () => {
		const title = eventData?.eventName || "Event";
		const address = eventData?.eventDetails?.eventType !== "online"
			? eventData?.eventDetails?.eventAddress?.formattedAddress
			: "";

		const makeEntry = (rawDate, durationKey) => {
			if (!rawDate) return null;
			const durationMins = parseDurationMinutes(durationKey);
			const startMoment = moment.utc(rawDate);
			const endMoment = moment.utc(rawDate).add(durationMins, "minutes");
			return {
				start: startMoment.format("YYYYMMDDTHHmmss"),
				end: endMoment.format("YYYYMMDDTHHmmss"),
				isoStart: startMoment.format("YYYY-MM-DDTHH:mm:ss"),
				isoEnd: endMoment.format("YYYY-MM-DDTHH:mm:ss"),
				title,
				address,
			};
		};

		if (!eventData?.multiEvents) {
			const entry = makeEntry(eventData?.date, eventData?.eventDuration?.key);
			return entry ? [entry] : [];
		}

		if (eventData.multiEventsType === "grouped") {
			return (eventData.multiEventsDates || [])
				.map(d => makeEntry(d?.eventDate, d?.eventDuration?.key))
				.filter(Boolean);
		}

		const onRegPrice = eventData?.eventPricing?.prices?.find(
			p => p?.type === "onRegistration" && p?.variant
		);
		const rawVariantInfo = onRegPrice?.variantInfo || {};
		const hasMultiDateVariants = Object.values(rawVariantInfo).some(v => v?.eventDate);
		const seen = new Set();
		const entries = [];

		if (hasMultiDateVariants) {
			(selectedVariants || formik?.values?.selectedVariants || []).forEach(ticketVarMap => {
				Object.values(ticketVarMap || {}).forEach(variantKey => {
					const info = variantKey && rawVariantInfo[variantKey];
					if (info?.eventDate && !seen.has(info.eventDate)) {
						seen.add(info.eventDate);
						const entry = makeEntry(info.eventDate, info?.eventDuration?.key);
						if (entry) entries.push(entry);
					}
				});
			});
		} else {
			(selectedEventDates || formik?.values?.selectedEventDates || []).forEach(ticketDates => {
				(ticketDates || []).forEach(idx => {
					const d = (eventData?.multiEventsDates || [])[idx];
					if (d?.eventDate && !seen.has(d.eventDate)) {
						seen.add(d.eventDate);
						const entry = makeEntry(d.eventDate, d?.eventDuration?.key);
						if (entry) entries.push(entry);
					}
				});
			});
		}

		return entries;
	};

	const generateICS = (entries) => {
		const location = entries[0]?.address;
		const dtstamp = moment.utc().format("YYYYMMDDTHHmmss") + "Z";
		const vevents = entries.map(({ start, end, title }, index) => [
			"BEGIN:VEVENT",
			`UID:event-${index}-${Date.now()}@eventapp`,
			`DTSTAMP:${dtstamp}`,
			`DTSTART:${start}`,
			`DTEND:${end}`,
			`SUMMARY:${title}`,
			location ? `LOCATION:${location}` : "",
		].filter(Boolean).join("\r\n") + "\r\nEND:VEVENT").join("\r\n");
		return `BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//EventApp//EN\r\nCALSCALE:GREGORIAN\r\n${vevents}\r\nEND:VCALENDAR`;
	};

	const downloadICS = (entries) => {
		const ics = generateICS(entries);
		const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
		const url = URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		a.download = `${(eventData?.eventName || "event").replace(/\s+/g, "_")}.ics`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(url);
	};

	const buildCalendarUrl = (type, entry) => {
		if (type === "google") {
			const params = new URLSearchParams({ action: "TEMPLATE", text: entry.title, dates: `${entry.start}/${entry.end}` });
			if (entry.address) params.set("location", entry.address);
			return `https://calendar.google.com/calendar/render?${params.toString()}`;
		}
		if (type === "outlook") {
			const params = new URLSearchParams({ subject: entry.title, startdt: entry.isoStart, enddt: entry.isoEnd, path: "/calendar/action/compose", rru: "addevent" });
			if (entry.address) params.set("location", entry.address);
			return `https://outlook.live.com/calendar/0/deeplink/compose?${params.toString()}`;
		}
		if (type === "office365") {
			const params = new URLSearchParams({ subject: entry.title, startdt: entry.isoStart, enddt: entry.isoEnd, path: "/calendar/action/compose", rru: "addevent" });
			if (entry.address) params.set("location", entry.address);
			return `https://outlook.office.com/calendar/action/compose?${params.toString()}`;
		}
		if (type === "yahoo") {
			const params = new URLSearchParams({ v: "60", title: entry.title, st: entry.start, et: entry.end });
			if (entry.address) params.set("in_loc", entry.address);
			return `https://calendar.yahoo.com/?${params.toString()}`;
		}
		return "";
	};

	const handleCalendarOption = (type) => {
		const entries = getCalendarEntries();
		if (entries.length === 0) return;

		if (type === "ics" || type === "share" || type === "apple") {
			downloadICS(entries);
			return;
		}

		// Single date — open the specific calendar URL
		const url = buildCalendarUrl(type, entries[0]);
		if (url) window.open(url, "_blank", "noopener,noreferrer");
	};

	const calendarEntries = getCalendarEntries();

	return (
		<Wrapper>
			<CardContent isMobile={isMobile}>
				{result === "success" ? (
					<div>
						<SucessIcon />
						{showThanksMsg ? (
							<ThanksMsg>Thank you, your account has been billed</ThanksMsg>
						) : (
							<>
								<Title isMobile={isMobile}>{successTitle}</Title>
								{isTherePayment && <p>Thank you! Your payment has been processed successfully.</p>}
							</>
						)}
						{!isFromApp && (
							<ButtonWrapper>
								{calendarEntries.length > 0 && (
									<ShareButton onClick={() => handleCalendarOption("share")}>
										<IcsCalendarIcon /> Add to Calendar
									</ShareButton>
								)}
								<DoneButton onClick={handleCancel}>Done</DoneButton>
							</ButtonWrapper>
						)}
					</div>
				) : (
					<div>
						<FailedIcon />
						<Title isMobile={isMobile}>Payment Failed!</Title>
						<p>
							Unfortunately we were unable to charge your payment ending in {lastCardNum}. Please try again to continue.
						</p>
						<ButtonWrapper>
							<CalendarButton onClick={() => formik.setFieldValue("resultPage", "")}>Try Again</CalendarButton>
							<DoneButton onClick={handleCancel}>Cancel</DoneButton>
						</ButtonWrapper>
					</div>
				)}
			</CardContent>
		</Wrapper>
	);
};
